import React from 'react';

import TalkBase from '../_talk';
import talk from './realtime-websockets.json';

export default () => <TalkBase talk={talk} />;



// WEBPACK FOOTER //
// ./pages/talks/realtime-websockets/index.js